import React, { useState } from "react"
import CategoryIcon from "./CategoryIcon"
import PartsNavigation from "./PartsNavigation"
import styled from "styled-components"
import { useParts } from "../provider/PartsContext"
const CategoryNavigationWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  gap: 0;
  flex-wrap: nowrap;
  width: 30vw;
  left: 50%;
  transform: translateX(-50%);
  @media (max-width: 1920px) {
    width: 30vw;
  }
  @media (max-width: 1600px) {
    width: 50vw;
  }
  @media (max-width: 1200px) {
    width: 50vw;
  }
  @media (max-width: 1000px) {
    width: 80vw;
  }
  @media (max-width: 500px) {
    width: 70vw;
  }
`

const CategoryNavigation = () => {
  console.log("CategoryNavigation")
  const { models, setModels } = useParts()
  const [currentCategory, setCurrentCategory] = useState(null)
  const [visiblePartsNavi, setVisiblePartsNavi] = useState(false)

  const onCategoryClickHandler = (category) => {
    console.log("category : ", category)
    setCurrentCategory(category)
    setVisiblePartsNavi(true)
  }

  const onPartItemClickHandler = (item) => {
    console.log("setPart : ", (prevState) => ({
      ...prevState,
      [item.category]: {
        ...prevState[item.category],
        path: item.path,
      },
    }))
    setModels((prevState) => ({
      ...prevState,
      [item.category]: {
        ...prevState[item.category],
        path: item.path,
      },
    }))
    setCurrentCategory(item)
    setVisiblePartsNavi(false)
  }

  return (
    <>
      <CategoryNavigationWrapper>
        {Object.entries(models).map(([key, model]) => {
          return (
            <CategoryIcon
              key={key}
              category={key}
              model={model}
              onClick={() => onCategoryClickHandler(key)}
            />
          )
        })}
      </CategoryNavigationWrapper>
      {visiblePartsNavi && (
        <PartsNavigation
          category={currentCategory}
          visible={visiblePartsNavi}
          onClick={() => onPartItemClickHandler}
        />
      )}
    </>
  )
}
export default CategoryNavigation
